







































import { Component, Inject, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';
import { ProvidedFormParam } from './types';
import { CSSStyleOptions } from '../common-types';

const cssPrefix = 'sw-form-row';

/**
 * This component will have as less props as possible, since most of props will
 * come from parent sw-form component.
 */
@Component
export default class SwFormRow extends SwExtendedVue {
  @Prop({ type: Boolean, default: false })
  noLabel: boolean;

  @Inject()
  formParam: ProvidedFormParam;

  cssPrefix = cssPrefix;

  get labelStyle(): CSSStyleOptions {
    return {
      width: typeof this.formParam.labelWidth === 'string' ? this.formParam.labelWidth : `${this.formParam.labelWidth}px`,
    };
  }
}
